export const pin = {
	className: 'icon-pin',
	viewBox: '0 0 161.21801 207.94502',
	paths: ['m 161.218,80.617 c 0,17.846 -5.975,35.271 -16.873,49.342 -0.25,0.625 -0.59,1.223 -1.012,1.771 l -56.68,73.348 c -1.4,1.807 -3.557,2.867 -5.842,2.867 -2.283,0 -4.441,-1.061 -5.838,-2.867 L 18.328,131.785 C 18.314,131.767 18.305,131.75 18.289,131.734 6.492,117.377 0,99.234 0,80.616 0,36.164 36.164,0 80.619,0 c 44.443,0.001 80.599,36.165 80.599,80.617 z']
}
